module.exports = __webpack_public_path__ + "img/y-254.e805eb08.png";